// import React from 'react'
import { graphql, Link } from 'gatsby'
import { Helmet } from "react-helmet"

import { MdVerifiedUser } from 'react-icons/md'

import Layout from '../components/layout'
import SEO from "../components/seo"

/** @jsx jsx */
import { Container, jsx } from 'theme-ui'

import SingleListing from '../components/singleListing'

const Listing = (props) => {
    const entreprise = props.data.prismicEntreprise.data
    // console.log("Entreprise", entreprise)

    const tags = props.data.prismicEntreprise.tags
    const category = props.pageContext.category

    const pitch = entreprise.pitch.text
    const name = entreprise.record.text
    const url = entreprise.website.url
    const telephone = entreprise.phone_number ? entreprise.phone_number.replace(/\s+/g, "") : null
    const email = entreprise.contact_email
    const logo = entreprise.logo.fixed
    const color = entreprise.maincolor 
    const locations = entreprise.locations
    const cover = entreprise.cover.fluid
    const verified = entreprise.verified
    const guest = entreprise.guest
    const draft = entreprise.draft

    const blocks = entreprise.body

    // console.log("ENTREPRISE", props.data.prismicEntreprise)

    const sites = props.data.site.siteMetadata.localGraphSites
    const listingCategories = entreprise.categories.map(i => i.category.uid)

    // console.log(sites)
    // console.log("Site category", category)
    // console.log("Entreprise category", listingCategories)
    let canonical

    // if listingCategories has two or more categories
    if ( listingCategories.length > 1 ) {
      // take first category
      let canonicalCategory = listingCategories[0]
      // console.log("Canonical category is", canonicalCategory)

      // from list of all site categories, find the one with that category
      let canonicalSite = sites.find(site => site.id === canonicalCategory)
      // console.log(canonicalSite.url)

      // if found then update helmet with canonical URL
      if ( canonicalSite ) {
        canonical = `https://www.${canonicalSite.url}/${props.data.prismicEntreprise.uid}`
        console.log("Canonical URL", canonical)
      }

      // if not found then do nothing
    }


    return (
        <Layout>
            <SEO title={name} description={pitch} article={true} noindex={draft} />

            {canonical && <Helmet>
              <link rel="canonical" href={canonical} />
            </Helmet>}

            <Container>
              <SingleListing 
                entreprise={entreprise}
                pitch={pitch}
                name={name}
                url={url}
                telephone={telephone}
                email={email}
                logo={logo}
                cover={cover}
                color={color}
                locations={locations}
                blocks={blocks}
                verified={verified}
                tags={tags.filter( tag => tag !== category )}
              />
            </Container>

            {!blocks.length > 0 && ( guest || !verified ) &&
              <div>
                <p sx={{
                  textAlign: 'center',
                  color: 'grey',
                  fontSize: 1,
                }}><MdVerifiedUser sx={{mb: '-3px', color: 'green'}} /> Cet établissement vous appartient ? <Link to="/referencement" sx={{color: "primary"}}>Contactez-nous</Link> pour authentifier et gérer ce listing.</p>
              </div>
            }
        </Layout>
    )
}

export default Listing

export const SingleListingQuery = graphql`
  query SingleListing($uid: String!) {
    prismicEntreprise(uid: { eq: $uid }) {
      uid
      ...ListingFragment
    }
    site {
      siteMetadata {
        siteTitle
        localGraphSites {
            id
            name
            url
        }
      }
    }
  }
` 